<template>
  <div>
    <div
      slot="header"
      v-html="caption"
    ></div>
    <b-row>
      <b-col
        class="my-1 form-inline"
        v-if="showPerPage"
      >
					<label class="mr-2">Per Page</label>
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
            @change="emitValue"
          ></b-form-select>
      </b-col>

      <b-col
        class="my-1"
        v-if="showSearch"
      >
        <b-form-group
          label="Search"
          label-cols-sm="2"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              type="search"
              id="filterInput"
              placeholder="Type to Search"
							v-model="filter"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              <!-- <b-button>Clear</b-button> -->
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
			id="my-table"
			show-empty
      responsive
      :items="items"
      :fields="captions"
      :per-page="perPage"
      @row-clicked="rowClicked"
			:current-page="currentPage"
			:filter="filter"
			:busy="isBusy"
      :sort-by="sortBy"
			hover striped bordered small fixed
    >
      <template
        slot="Status"
        slot-scope="data"
      >
        <b-badge :variant="getBadge(data.item.Status)">{{ data.item.Status }}</b-badge>
				
      </template>

      <!-- EMPTY DISPLAY -->
      <template v-slot:empty="scope">
        <div class="text-center mt-2">
          <h6>No Results found..</h6>
        </div>
      </template>

			   <!-- FOR MULTI HEADER -->
      <template
        v-slot:thead-top="data"
        v-if="topHeader"
      >
        <tr>
          <template v-for="(item, key) in topHeader">
            <th
              variant="danger"
              :key="key"
              :colspan="item.colspan"
              :rowspan="item.rowspan"
            >
              {{ item.label }}
            </th>
          </template>
        </tr>
      </template>
      <!-- FOR MULTI HEADER -->

			<template v-slot:table-busy>
        <center>
          <div class="lds-ripple">
            <div></div>
            <div></div>
          </div>
          <div>
            <b>Loading...</b>
          </div>
        </center>
      </template>
      <!-- EMPTY DISPLAY -->

      <template
        slot="TransactionDate"
        slot-scope="row"
      >
        {{ convertDateFormat(row.item.TransactionDate) }}
      </template>

      <template
        slot="actions"
        slot-scope="row"
      >
			<b-button-group>
			<!-- 	<b-button
          variant="success"
          size="sm"
					class="mr-1"
          @click="$emit('tagAdjustment', row)"
          v-if="showTagAdjustment == true"
        ><i class="fa fa-arrows"></i> Tag Adjustments</b-button> -->

				<b-button
          variant="success"
          size="sm"
					class="mr-1"
          @click="$emit('payrollDetail', row)"
          v-if="row.item.Status != 'Posted' "
        ><i class="fa fa-cog"></i> </b-button>

				<b-button
          variant="success"
          size="sm"
					class="mr-1"
          @click="$emit('payrollDetail', row)"
          v-if="row.item.Status == 'Posted' "
        ><i class="fa fa-eye"></i> </b-button>

				<b-button
          variant="warning"
          size="sm"
					class="mr-1"
          @click="$emit('payrollSummary', row)"
          v-if="row.item.Status == 'Posted' || row.item.Status == 'Computed' || row.item.Status == 'For Approval'"
        ><i class="fa fa-file"></i> </b-button>


        <b-button
          variant="warning"
          size="sm"
          class="mr-1"
          @click="$emit('editItem', row)"
					v-if="row.item.Status != 'Posted'"
        ><i class="fa fa-pencil"></i></b-button>

        <b-button
          variant="danger"
          size="sm"
          @click="$emit('deleteItem', row)"
          class="mr-1"
					v-if="row.item.Status == 'Created' || row.item.Status == 'Uploaded'"
        ><i class="fa fa-trash"></i> </b-button>
        <!-- <b-button
          variant="success"
          size="sm"
          @click="$emit('restoreItem', row)"
          v-if="row.item.deleted_at !== null && showRestoreButton == true"
        ><i class="fa fa-undo"></i> Restore</b-button> -->

        <b-button
          variant="info"
          size="sm"
          @click="$emit('downloadItem', row)"
          v-if="showDownloadButton == true"
        ><i class="fa fa-download"></i> Download</b-button>
			</b-button-group>
				

      </template>
    </b-table>

    <b-row v-if="getRowCount() != 0">
      <b-col>
        <!-- <p>
          Showing {{ (currentPage * perPage) - (perPage - 1 ) }} to {{ Math.min(currentPage * perPage, totalRows) }} of
          {{ totalRows }} entries
        </p> -->
      </b-col> 
      <b-col>
        <nav class="pull-right">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <!-- {{ apiData.total }} -->
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "c-table",
  inheritAttrs: false,
  props: {
    sortBy: {
      type: String,
      default: null
    },
		topHeader: {
      type: Array,
      default: null
    },
    apiData: {
      type: Array,
      default: null
    },
    total: {
      type: Number,
      default: 0
    },
    caption: {
      type: String,
      default: ""
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    dark: {
      type: Boolean,
      default: false
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => []
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    showPerPage: {
      type: Boolean,
      default: true
    },
    editText: {
      type: String,
      default: "Edit"
    },
    deleteText: {
      type: String,
      default: "Delete"
    },
    showEditButton: {
      type: Boolean,
      default: true
    },
    showDeleteButton: {
      type: Boolean,
      default: true
    },
    showRestoreButton: {
      type: Boolean,
      default: true
    },
    showDownloadButton: {
      type: Boolean,
      default: false
		},
		showTagAdjustment: {
      type: Boolean,
      default: false
		},
		isBusy: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
			perPage: 15,
      currentPage: 1,
      pageOptions: [5, 10, 15, 50],
			limit: 15,
			filter: null,
    };
  },
  computed: {
    // items: function() {
    //   const items = this.tableData;
    //   return Array.isArray(items) ? items : items();
    // },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  mounted() {
    this.limit = this.perPage;
  },
  methods: {
    convertDateFormat(value){
      let formatted_date = moment(value.substring(0,10)).format('MMM DD, YYYY');
      return formatted_date;
    },
    getBadge(status) {
      if(status === 'Posted'){
        return 'success';
      } else if(status === 'Rejected'){
        return 'danger'
      }  else if(status === 'For Approval'){
        return 'warning'
      } else {
        return 'info'
      }
    },
    getRowCount: function() {
      //return this.items.length
      if (this.items) {
        // console.log(this.tableData);
        return this.items.length;
      }
      return 0;
    },
    rowClicked(item) {
      this.$emit("row-clicked", item);
    },
    changePage(payload) {
      this.$emit("changePage", payload);
    },
    emitValue(payload) {
      this.$emit("change_per_page", payload);
    }
  }
};
</script>


<style lang="css" scoped>
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #2f353a;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>

